<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="col-sm-12 nopads">
    <transition name="fade">
      <div v-if="streetCables.length > 0" class="list-content result-table">
        <vue3-datatable
          :rows="streetCables"
          :columns="fields"
          :pagination="false"
          :sticky-header="true"
          height="50vh"
          :sortable="true"
          skin="bh-table-compact"
          row-class="routa-table-row"
          cell-class="routa-table-cell"
          @row-click="rowClicked"
        >
        </vue3-datatable>
      </div>
    </Transition>
  </div>
</template>

<script>

import {timeUtils} from "@/components/mixins/TimeUtils";
import {cableHelper} from "@/components/mixins/CableMixin";
import {streetLightHelper} from "@/components/mixins/StreetLightMixin";
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'CableList',
    components: {Vue3Datatable},
    mixins: [timeUtils, cableHelper, streetLightHelper],
    props: {
        cables: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            sortBy: 'id',
            sortDesc: false,
            streetCables: []
        }
    },
    computed: {
        fields() {
            return [
                {field: 'id', title: this.$t('common.id'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'purpose', title: this.$t('cables.purpose'), sort: true, headerClass: 'routa-table-header'},
                {field: 'type', title: this.$t('cables.type'), sort: true, headerClass: 'routa-table-header'},
                {field: 'station.location_name', title: this.$t('street_lights.station'), sort: true, headerClass: 'routa-table-header'},
                {field: 'status', title: this.$t('street_lights.status'), sort: true, headerClass: 'routa-table-header'},
            ]
        }
    },
    watch: {
        cables() {
            this.streetCables = []
            let temp = []
            this.cables.forEach(item => {
                let newItem = JSON.parse(JSON.stringify(item));
                newItem.status = item.status ? this.getStatusString(item.status) : ''
                newItem.purpose = this.getPurposeString(item.purpose)
                newItem.type = this.getTypeString(item.type)
                temp.push(newItem)
            })
            this.$nextTick(() => {
                this.streetCables = temp
            })
        }
    },
    mounted() {
        this.streetCables = this.cables
    },
    methods: {
        rowClicked: function (details) {
            this.$emit('rowClicked', details)
        }
    }
}
</script>
